import React, { useState } from 'react';
import styled from 'styled-components';
import {
  AppCard,
  AppCheckbox,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalIndustrialNormalAspectsCard(
  props
) {
  const {
    index,
    filterApplicable,
    values,
    motive,
    subphase,
    frequencyOptions,
    quantityOptions,
    setFieldValue,
  } = props;
  const [valuationText] = useState([
    <Translator
      file="module-comsaEnvironmental"
      name="no.applicable"
    />,
    <Translator file="module-comsaEnvironmental" name="not-significant" />,
    <Translator file="module-comsaEnvironmental" name="significant" />,
  ]);

  if (filterApplicable && !values?.[index]?.applicable) return null;

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <AppCheckbox
        title={
          values?.[index]?.applicable
            ? ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="no.applicable"
                />
              )
            : ReactDOMServer.renderToString(
                <Translator
                  file="module-comsaEnvironmental"
                  name="assign.as.applicable"
                />
              )
        }
        value={values?.[index]?.applicable}
        className="d-inline-flex"
        onChange={(v) => setFieldValue(`[${index}].applicable`, v)}
      />
      <AppCardContainer
        className="mb-2"
        bodyClassName="p-1"
        $applicable={values?.[index]?.applicable}
      >
        <div className="info-block">
          <div className="line mb-2">
            <div>
              <Translator file="module-comsaEnvironmental" name="sub-phase" />:
            </div>
            <div className="mb-2">
              <b>
                <Translator file="module-comsaEnvironmental" name={subphase} />
              </b>
            </div>
            <div>
              <Translator file="module-comsaEnvironmental" name="reason" />:
            </div>
            <div>
              <b>
                <Translator file="module-comsaEnvironmental" name={motive} />
              </b>
            </div>
          </div>
          <div className="line no-center mb-2">
            <AppSingleSelect
              options={frequencyOptions}
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="frequency" />
              )}
              value={values?.[index]?.frequency}
              onChange={(v) => setFieldValue(`[${index}].frequency`, v)}
            />
            <AppSingleSelect
              options={quantityOptions}
              title={ReactDOMServer.renderToString(
                <Translator file="module-comsaEnvironmental" name="quantity" />
              )}
              value={values?.[index]?.quantity}
              onChange={(v) => setFieldValue(`[${index}].quantity`, v)}
            />
          </div>
          <div className="line mb-2">
            <div>
              <Translator
                file="module-comsaEnvironmental"
                name="risk.assessment"
              />
              :
            </div>
            <div
              className={
                values?.[index]?.evaluation === 2
                  ? 'text-danger'
                  : values?.[index]?.evaluation === 1
                  ? 'text-warning'
                  : 'text-success'
              }
            >
              <b>{valuationText[values?.[index]?.evaluation] || ''}</b>
            </div>
          </div>
        </div>
      </AppCardContainer>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const AppCardContainer = styled(AppCard)`
  border: 2px solid ${(props) => (props.$applicable ? '#28a745' : '#fff')};
  .info-block {
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      color: ${colors.primaryLight};
      &.no-center {
        text-align: left;
      }
    }
  }
`;
